import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";
import { createFormData } from "../utils/dataParser";

const axiosInstance = getAxiosInstance();

export const signinAPI = (data) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post("/api/user/login", data)
      .then((res) => {
        delete res.message;
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const verify2FAAPI = (data) => {
  return new Promise((resolve, reject) => {
    // Прибираємо firebase токени з запиту
    const requestData = {
      userId: data.userId,
      code: data.code,
      remember: data.remember,
    };

    axiosInstance
      .post("/api/user/verify-2fa", requestData)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// NEW: resend 2FA code (60s delay)
export const resend2FAAPI = (data) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post("/api/user//2fa/resend", data) // заміни шлях, якщо у тебе інший
      .then((res) => {
        resolve(res.data); // очікуємо { success, cooldown, message }
      })
      .catch((err) => {
        reject(err); // у разі 429 бек повертає cooldown в err.response.data
      });
  });
};

export const checkUserByEmailAPI = (email) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get("/api/user/check-email", {
        params: { email }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err?.response?.data || err);
      });
  });
};

export const checkUsernameAPI = (username) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .get("/api/user/check-username", {
        params: { username },
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err?.response?.data || err);
      });
  });
};

export const googleSignInAPI = (data) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post("/api/user/google-login", data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const signupAPI = (data) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post("/api/user/register", data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const googleSignUpAPI = (data) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post("/api/user/google-register", data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const forgotPasswordAPI = (data) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post("/api/user/forgot-password", data)
      .then((res) => resolve(res.data))
      .catch((err) => {
        reject(err.data);
      });
  });
};

export const resetPasswordAPI = (data) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post("/api/user/reset-password", data)
      .then((res) => resolve(res.data))
      .catch((err) => {
        reject(err.data);
      });
  });
};

export const resetPasswordTokenAPI = (data) => {
  return new Promise((resolve, reject) => {
    // Підтримуємо як body, так і query параметр token
    // Якщо є тільки token без newPassword, використовуємо query параметр
    const hasPasswordData = data.newPassword && data.confirmPassword;

    const url = data.token && !hasPasswordData
      ? `/api/user/reset-password-token?token=${encodeURIComponent(data.token)}`
      : "/api/user/reset-password-token";

    // Якщо token в query, не додаємо його в body
    const body = hasPasswordData
      ? { token: data.token, newPassword: data.newPassword, confirmPassword: data.confirmPassword }
      : undefined;

    axiosInstance
      .post(url, body)
      .then((res) => resolve(res.data))
      .catch((err) => {
        reject(err.response?.data || err.data || err);
      });
  });
};

export const verifyEmailAPI = (data, useGet = false) => {
  return new Promise((resolve, reject) => {
    // Підтримуємо як GET, так і POST запити
    const isStringToken = typeof data === 'string';
    const isTokenOnly = data.token && Object.keys(data).length === 1;

    // Якщо useGet=true або передано тільки токен як рядок, використовуємо GET
    const shouldUseGet = useGet || isStringToken || isTokenOnly;

    const url = shouldUseGet
      ? `/api/user/verify-email?token=${encodeURIComponent(isStringToken ? data : data.token)}`
      : "/api/user/verify-email";

    const body = shouldUseGet
      ? undefined
      : { token: isStringToken ? data : data.token };

    const requestMethod = shouldUseGet ? 'get' : 'post';

    axiosInstance[requestMethod](url, body)
      .then((res) => {
        // Якщо GET запит повернув редирект (302), бекенд вже обробив верифікацію
        // У цьому випадку ми можемо отримати помилку або редирект
        resolve(res.data || { success: true });
      })
      .catch((err) => {
        // Якщо це редирект (302), це нормально - бекенд вже обробив верифікацію
        if (err?.response?.status === 302 || err?.response?.status === 200) {
          resolve({ success: true });
        } else {
          reject(err.response?.data || err.data || err);
        }
      });
  });
};

export const getCreatorSuggestionsAPI = (
  page,
  perPage,
  excludeViewers = true,
  filters = {},
) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    const params = {
      page,
      perPage,
      excludeViewers, // Додаємо параметр для виключення переглядачів
      ...filters,
    };


    axiosInstance
      .get("/api/user/creator-suggestions", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.error("API Error:", err);
        reject(err.data);
      });
  });
};
export const getGalleryPostCommentsAPI = (
  galleryPostId,
  commentId = null,
  query,
) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/gallery/post/comments", {
        params: {
          galleryPostId: galleryPostId,
          commentId: commentId,
          ...query,
        },
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

export const checkUserSubscriptionAPI = (creatorId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .get(`/api/ccbill/payment/subscriptions/check/${creatorId}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const likeGalleryPostAPI = (galleryPostId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        "/api/user/gallery/post/like",
        {},
        {
          params: {
            galleryPostId: galleryPostId,
          },
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.data));
  });
};

export const shareGalleryPostAPI = (galleryPostId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        "/api/user/gallery/post/share",
        {},
        {
          params: {
            galleryPostId: galleryPostId,
          },
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.data));
  });
};

export const sendCommentToPostAPI = (comment, query) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        "/api/user/gallery/post/comment",
        {
          comment: comment,
        },
        {
          params: query,
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.response.data));
  });
};

// PATCH /gallery/post/:postId — оновлення опису/хештегів/ціни (лише власник)
export const updateGalleryPostAPI = (postId, payload) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch(`/api/user/gallery/${postId}`, payload, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then(res => resolve(res.data))
      .catch(err => reject(err?.response?.data || err));
  });
};

// PATCH /gallery/post/comment/:commentId — оновлення коментаря (автор або власник поста)
export const updateGalleryCommentAPI = (commentId, payload) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch(`/api/user/gallery/post/comment/${commentId}`, payload, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then(res => resolve(res.data))
      .catch(err => reject(err?.response?.data || err));
  });
};

// DELETE /gallery/post/comment/:commentId — видалення коментаря (автор коментаря)
export const deleteGalleryCommentAPI = (commentId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .delete(`/api/user/gallery/post/comment/${commentId}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then(res => resolve(res.data))
      .catch(err => reject(err?.response?.data || err));
  });
};

export const followUserAPI = (userId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        "/api/user/follow",
        {},
        {
          params: {
            userId: userId,
          },
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.data));
  });
};

export const setUserFollowStatusAPI = (userId, followStatus) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        "/api/user/follower/status",
        {},
        {
          params: {
            userId: userId,
            status: followStatus,
          },
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.data));
  });
};

export const getUserFollowersAPI = (userId, options = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/followers", {
        params: {
          userId: userId,
          ...options,
        },
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.data));
  });
};

export const getUserFollowingsAPI = (options = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/following", {
        params: options,
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.data));
  });
};
export const toggle2FASettingAPI = (enabled) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .put(
        "/api/user/2fa",
        { enabled },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.response?.data || err));
  });
};

export const searchAll = (query, options = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    const params = {
      query,
      ...(options || {}),
    };
    axiosInstance
      .get("/api/user/search/all", {
        params,
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.response?.data || err));
  });
};

export const getUserProfile = (id) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/profile", {
        params: { id: !isId(id) ? undefined : id, username: isId(id) ? undefined : id },
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.data));
  });
};

export const getUserPersonalInfo = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/personal-info", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.response?.data || err));
  });
};

// Creator subscription plans (max 3 per creator)
export const getMySubscriptionPlansAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/profile/subscription-plans", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const getCreatorSubscriptionPlansAPI = (userId) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(`/api/user/profile/${userId}/subscription-plans`, {
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// New creator subscribe endpoints (free + trial)
export const subscribeFreeToCreatorAPI = (creatorId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(`/api/user/profile/${creatorId}/subscribe-free`, {}, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const startTrialForCreatorAPI = (creatorId, planId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(`/api/user/profile/${creatorId}/start-trial`, { planId }, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Creator subscription settings (freeEnabled/trialEnabled + freePlan)
export const getMySubscriptionSettingsAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/profile/subscription-settings", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const patchMySubscriptionSettingsAPI = (payload) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch("/api/user/profile/subscription-settings", payload, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const createSubscriptionPlanAPI = (payload) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post("/api/user/profile/subscription-plans", payload, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const updateSubscriptionPlanAPI = (planId, payload) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch(`/api/user/profile/subscription-plans/${planId}`, payload, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const deleteSubscriptionPlanAPI = (planId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .delete(`/api/user/profile/subscription-plans/${planId}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const getMyLikedPosts = (options = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .get("/api/user/liked-posts", {
        params: options,
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => {
        const { items, totalPages, currentPage, totalCount } = res.data;
        resolve({ items, totalPages, currentPage, totalCount });
      })
      .catch((err) => reject(err?.data || err));
  });
};

export const getMySharedPosts = (options = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .get("/api/user/shared-posts", {
        params: options,
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => {
        const { items, totalPages, currentPage, totalCount } = res.data;
        resolve({ items, totalPages, currentPage, totalCount });
      })
      .catch((err) => reject(err?.data || err));
  });
};

export function isId(value) {
  // Check if it's exactly 24 hex characters (MongoDB ObjectId format)
  return /^[a-fA-F0-9]{24}$/.test(value);
}

export const getUserGalleryPostsAPI = (id, options = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/gallery", {
        params: {
          id: !isId(id) ? undefined : id,
          username: isId(id) ? undefined : id,
          ...options,
        },
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.data));
  });
};
// api/userApi.ts (або де в тебе інші методи)
export const togglePinPostAPI = (postId, pinned) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        `/api/user/gallery/${postId}/pin`,
        { pinned },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const reportPostAPI = (postId, payload) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(`/api/user/posts/${postId}/report`, payload, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const reportProfileAPI = (userId, payload) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(`/api/user/profile/${userId}/report`, payload, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
export const reportCommentAPI = (commentId, payload) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(`/api/user/gallery/post/comment/${commentId}/report`, payload, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const addBookmarkAPI = (postId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        `/api/user/posts/bookmarks/add`,
        { postId },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Get all bookmark collections
export const getBookmarkCollectionsAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get(`/api/bookmarks`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Get specific bookmark collection with posts
export const getBookmarkCollectionAPI = (collectionId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get(`/api/bookmarks/${collectionId}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Get bookmarks from default collection (backward compatibility)
export const getBookmarksAPI = ({ page = 1, limit = 20 } = {}) => {
  return new Promise((resolve, reject) => {
    // First get all collections to find default one
    getBookmarkCollectionsAPI()
      .then((collectionsData) => {
        const collections = collectionsData?.data?.collections || [];
        const defaultCollection = collections.find((c) => c.isDefault);

        if (!defaultCollection) {
          // If no default collection, return empty
          resolve({
            items: [],
            totalCount: 0,
            totalPages: 0,
          });
          return;
        }

        // Get posts from default collection
        return getBookmarkCollectionAPI(defaultCollection._id);
      })
      .then((collectionData) => {
        const items = collectionData?.data?.items || [];
        const totalCount = items.length;
        const totalPages = Math.ceil(totalCount / limit);
        const startIndex = (page - 1) * limit;
        const endIndex = startIndex + limit;
        const paginatedItems = items.slice(startIndex, endIndex);

        // Transform items to match old format
        const transformedItems = paginatedItems.map((item) => ({
          ...item.postId,
          addedAt: item.addedAt,
        }));

        resolve({
          items: transformedItems,
          totalCount,
          totalPages,
        });
      })
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Create bookmark collection
export const createBookmarkCollectionAPI = ({ name, isDefault = false }) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        `/api/bookmarks`,
        { name, isDefault },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Update bookmark collection
export const updateBookmarkCollectionAPI = (collectionId, { name, isDefault }) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .put(
        `/api/bookmarks/${collectionId}`,
        { name, isDefault },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Delete bookmark collection
export const deleteBookmarkCollectionAPI = (collectionId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .delete(`/api/bookmarks/${collectionId}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Add post to collection
export const addPostToCollectionAPI = (collectionId, postId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        `/api/bookmarks/${collectionId}/add`,
        { postId },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Remove post from collection
export const removePostFromCollectionAPI = (collectionId, postId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .delete(`/api/bookmarks/${collectionId}/remove/${postId}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Check post bookmark status
export const checkPostBookmarkStatusAPI = (postId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get(`/api/bookmarks/posts/${postId}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Remove post from bookmarks (backward compatibility - removes from all collections or specific)
export const removeBookmarkAPI = (postId, collectionId = null) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    const url = collectionId
      ? `/api/bookmarks/remove/${postId}?collectionId=${collectionId}`
      : `/api/bookmarks/remove/${postId}`;
    axiosInstance
      .delete(url, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const getUserGalleryPostsAPIi = (ownerId, options = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    const headers = {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    };
    if (tokens?.access_token) {
      headers[process.env.REACT_APP_AUTH_TOKEN] =
        `Bearer ${tokens.access_token}`;
    }
    axiosInstance
      .get("/api/user/gallery", {
        params: {
          id: ownerId,
          ...options,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.data));
  });
};

export const getUserGalleryPostAPI = (userId, postId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/gallery/post", {
        params: {
          userId: userId,
          galleryPostId: postId,
        },
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.data));
  });
};

export const getUserGalleryPostCommentsAPI = (
  userId,
  postId,
  commentId = null,
  options = {},
) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/gallery/post/comments", {
        params: {
          userId: userId,
          galleryPostId: postId,
          commentId: commentId,
          ...options,
        },
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.data));
  });
};

export const editProfileDataAPI = (data) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    const payload = data instanceof FormData ? data : createFormData(data);
    axiosInstance
      .patch("/api/user/editProfileData", payload, {
        headers: {
          // Let browser automatically set Content-Type with boundary for multipart/form-data
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve({ ...res.data }))
      .catch((err) => reject(err.response.data));
  });
};

export const getUserReferralsAPI = (userId, options = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get(`/api/user/referral/user/${userId}`, {
        params: {
          page: options.page || 1,
          limit: options.limit || 10,
          status: options.status || undefined,
          ...options,
        },
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// GET /api/user/profile/:userId/paid-subscriptions
// Повертає активні платні підписки користувача (як subscriber)
export const getPaidSubscriptionsByUserAPI = (userId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    if (!tokens?.access_token) {
      reject(new Error("Missing auth token"));
      return;
    }

    axiosInstance
      .get(`/api/user/profile/${userId}/paid-subscriptions`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const sendReferralEmailAPI = (email, referralLink) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        "/api/referral/send-email",
        { email, referralLink },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const deletePostAPI = (postId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .delete(`/api/user/gallery/${postId}`, {
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
        },
      })
      .then((res) => resolve({ ...res.data }))
      .catch((err) => reject(err));
  });
};

export const getNotificationSettingsAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/notifications", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

export const updateNotificationSettingsAPI = (data) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch("/api/user/notifications", data, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

export const getInAppNotificationsAPI = (query = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/notifications/in-app", {
        params: query,
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

export const getInAppNotificationsUnreadCountAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/notifications/in-app/unread-count", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

export const markNotificationAsReadAPI = (notificationId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch(
        `/api/user/notifications/in-app/${notificationId}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

export const markAllInAppNotificationsAsReadAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch(
        "/api/user/notifications/in-app/mark-all-read",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

export const getPrivacySettingsAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/privacy", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

export const updatePrivacySettingsAPI = (data) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch("/api/user/privacy", data, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

export const getPrivacySwitchesAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/privacy/switches", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const updatePrivacySwitchesAPI = (data) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch("/api/user/privacy/switches", data, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const idProofUploadAPI = (data) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    const formData = createFormData(data);

    axiosInstance
      .post("/api/user/uploadIdProof", formData, {
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => {
        reject(err.data);
      });
  });
};

// Fetch pending follow requests
export const getPendingFollowRequestsAPI = ({
  page = 1,
  perPage = 25,
  sortType = "desc",
} = {}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get(`/api/user/pending-follow-requests`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { page, perPage, sortType },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

// Handle follow request (accept or reject)
export const handleFollowRequestAPI = ({ requestId, action }) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        `/api/user/handle-follow-request`,
        { requestId, action }, // action: 'accept' or 'reject'
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

export const likeUserPostCommentAPI = (postId, commentId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        "/api/user/gallery/post/comment/like",
        {},
        {
          params: {
            galleryPostId: postId,
            commentId: commentId,
          },
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const blockUserAPI = (blockedId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        "/api/user/block",
        { blockedId },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.data || err));
  });
};

export const getBlockedUsersAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/block/list", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err?.data || err));
  });
};
export const unblockUserAPI = (blockedId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .delete(`/api/user/block/${blockedId}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err?.data || err));
  });
};

export const publicContentAPI = (data, onUploadProgress) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    const formData = createFormData(data);
    axiosInstance
      .post("/api/user/gallery/upload", formData, {
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
        },
        onUploadProgress: onUploadProgress
          ? (progressEvent) => onUploadProgress(progressEvent)
          : undefined,
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.response.data));
  });
};

export const getAgoraRTCAccessTokenAPI = (data) =>
  axiosInstance
    .post(`/api/user/generateAgoraRTCAccessToken`, data, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((res) => res.data)
    .catch((err) => {
    });

export const getAgoraRTMAccessTokenAPI = (data) =>
  axiosInstance
    .post(`/api/user/generateAgoraRTMAccessToken`, data, {
      headers: { token: localStorage.getItem("token") },
    })
    .then((res) => res.data)
    .catch(() => {
    });

export const getFileByIdAPI = (fileId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get(`/api/files/${fileId}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        responseType: "blob",
      })
      .then((res) => {
        const url = URL.createObjectURL(res.data);
        resolve(url);
      })
      .catch((err) => reject(err));
  });
};

export const getUserByUsernameAPI = (username) => {

  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .get(`/api/user/username/${username}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => {
        if (res.data.success) {
          resolve(res.data.data);
        } else {
          reject(new Error(res.data.error || 'User not found'));
        }
      })
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const changeUsernameAPI = (newUsername) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();

    axiosInstance
      .patch('/api/user/change-username', {
        username: newUsername
      }, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Refresh token API
export const refreshTokenAPI = (refreshToken) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post('/api/auth/refresh', {
        refresh_token: refreshToken  // Тільки JWT refresh token
      }, {
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Get first unviewed deleted post
export const getFirstUnviewedDeletedPostAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/posts/deleted/unviewed", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
export const getFirstUnviewedDeletedCommentAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/gallery/post/comment/deleted/unviewed", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
export const getFirstUnviewedDeletedProfileAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/profiles/deleted/unviewed", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const getUserBanStatusAPI = (userId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get(`/api/moderation/profile/${userId}/ban-status`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Mark post report as viewed
export const markPostReportAsViewedAPI = (reportId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(`/api/user/post-reports/${reportId}/viewed`, {}, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
export const markCommentReportAsViewedAPI = (reportId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(`/api/user/comment-reports/${reportId}/viewed`, {}, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

export const markProfileReportAsViewedAPI = (reportId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(`/api/user/profile-reports/${reportId}/viewed`, {}, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Create appeal for post
export const createAppealAPI = (targetId, targetType, reason, comment = "") => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(`/api/user/appeals`, {
        targetId,
        targetType, // "post","profile" or "comment"
        reason,
        comment,
      }, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Update modal create first post setting
export const updateModalCreateFirstPostAPI = (isModalCreateFirstPost) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch("/api/user/modal-create-first-post", {
        isModalCreateFirstPost,
      }, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Increment guide step
export const incrementGuideStepAPI = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post("/api/user/guide-steps/increment", {}, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};

// Update guide steps visibility
export const updateGuideStepsVisibilityAPI = (isShowGuideSteps) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch("/api/user/guide-steps", {
        isShowGuideSteps,
      }, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || err));
  });
};
